export default __webpack_public_path__ + "static/ctaModule_cloud_bottom_tablet-bdf082457ebba0d8905b49909eb4a118.png";